import React from "react";
import { useElasticData, useExtraData } from "./DataContext.js";

const OrderTrackIcons = () => {
    
    let { orderingData } = useElasticData();
    let { isGuestUser } = useExtraData();

    if(isGuestUser) return (<></>);

    const orderTrackIconsToolTip = (type, count, collection, displayFullHistory = false) => {
        let html = [];
        let zeroPhrase, nonZeroPhrase;
        switch(type){
            case "baskets": 
                zeroPhrase = "This book does not appear in any baskets";
                nonZeroPhrase = "Copies in baskets:";
            break;
            case "basketsAlt": 
                zeroPhrase = "There are no baskets containing alternate editions of this title";
                nonZeroPhrase = "Alternate editions in baskets:";
            break;
            case "orders": 
                zeroPhrase = "This book has not been ordered before";
                nonZeroPhrase = "Copies ordered:";
            break;
            case "ordersAlt": 
                zeroPhrase = "There are no orders containing alternate editions of this title";
                nonZeroPhrase = "Alternate editions ordered before:";
            break;
        }

        if (count == 0){
            html[0] = zeroPhrase;
        } else {
            html[0] = nonZeroPhrase;

            let i = 1;
            for (const item of collection) {

                let basketDisplayName = item.basketName ?? "Basket";
                
                if(item.branchCode) {
                    html[i] = `${item.quantity} for branch ${item.branchCode} in ${basketDisplayName}`;
                } else {
                    html[i] = `${item.quantity} in ${basketDisplayName}`;
                }

                // if(i > 8){
                //     html[9] = "...";
                //     break;
                // }

                i++;
            };
        }

        return html;
    }
    
    return (
        <>
            <div className="orderTrackIcons">
                <div className="needMore">
                    <i className="fas fa-shopping-basket"></i>
                    <span>{orderingData.orderTrackBasketsCount}</span>
                    <span className="searchToolTip">
                        <div className="tooltipDetails">
                            {orderingData.orderTrackBaskets && orderTrackIconsToolTip("baskets", orderingData.orderTrackBasketsCount, orderingData.orderTrackBaskets).map((b, i, a) => <span key={i}>{b}</span>)}
                        </div>
                    </span>
                </div>
                <div className="needMore alternativeEditions">
                    <i className="fas fa-shopping-basket"></i>
                    <span>{orderingData.orderTrackBasketsAltCount}</span>
                    <span className="searchToolTip">
                        <div className="tooltipDetails">
                            {orderingData.orderTrackBasketsAlt && orderTrackIconsToolTip("basketsAlt", orderingData.orderTrackBasketsAltCount, orderingData.orderTrackBasketsAlt).map((b, i, a) => <span key={i}>{b}</span>)}
                        </div>
                    </span>
                </div>
                <div className="needMore">
                    <i className="fas fa-calendar-check"></i>
                    <span>{orderingData.orderTrackOrdersCount}</span>
                    <span className="searchToolTip">
                        <div className="tooltipDetails">
                            {orderingData.orderTrackOrders && orderTrackIconsToolTip("orders", orderingData.orderTrackOrdersCount, orderingData.orderTrackOrders).map((b, i, a) => <span key={i}>{b}</span>)}
                        </div>
                    </span>
                </div>
                <div className="needMore alternativeEditions">
                    <i className="fas fa-calendar-check"></i>
                    <span>{orderingData.orderTrackOrdersAltCount}</span>
                    <span className="searchToolTip">
                        <div className="tooltipDetails">
                            {orderingData.orderTrackOrdersAlt && orderTrackIconsToolTip("ordersAlt", orderingData.orderTrackOrdersAltCount, orderingData.orderTrackOrdersAlt).map((b, i, a) => <span key={i}>{b}</span>)}
                        </div>
                    </span>
                </div>
            </div>
        </>
    );
}

export default OrderTrackIcons;